/// <reference path="../Task/TaskGrid.ts" />

namespace Nobox.CRM {

    import fld = TaskRow.Fields;

    @Serenity.Decorators.registerClass()
    export class DealsTaskGrid extends TaskGrid {
        protected getDialogType() { return TaskDialog; }
        public BoardId: string="";
        constructor(container: JQuery) {
            super(container);
        }

        protected initEntityDialog(itemType, dialog) {
            super.initEntityDialog(itemType, dialog);
            Serenity.SubDialogHelper.cascade(dialog, this.element.closest('.ui-dialog'));
        }

        protected addButtonClick() {
            this.editItem({ DealId: this.dealId, ShowBoard: this.BoardId });
        }


        protected getPersistanceStorage(): Serenity.SettingStorage {
            return window.localStorage;
        }

        protected getInitialTitle() {
            return null;
        }

        protected getGridCanLoad() {
            return super.getGridCanLoad() && !!this.dealId;
        }

        private _GroupID: string;

        get dealId() {
            return this._GroupID;
        }
        protected onViewSubmit(): boolean {
            if (!super.onViewSubmit()) { return false; }
            let request = this.view.params as Serenity.ListRequest;
            //request.ColumnSelection = 1;
            if (request.EqualityFilter != undefined) {
                request.EqualityFilter.DealId = this.dealId;
            } else {
                request.EqualityFilter = { DealId : this.dealId };
            }
        }
        set dealId(value: string) {
            if (this._GroupID !== value) {
                this._GroupID = value;
                this.refresh();
            }
        }
        protected getViewOptions() {
            let opt = super.getViewOptions();
            opt.rowsPerPage = 20;
            return opt;
        }
        protected getPagerOptions() {
            let opt = super.getPagerOptions();
            opt.rowsPerPageOptions = [10, 20, 50, 100, 500, 1000];
            return opt;
        }
    }
}